var map = {
	"./daily-selected.svg": 9173,
	"./daily.svg": 4703,
	"./home-selected.svg": 8134,
	"./home.svg": 1697,
	"./logout.svg": 2143,
	"./train-selected.svg": 1731,
	"./train.svg": 7953,
	"./user-selected.svg": 3582,
	"./user.svg": 6061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8074;